/**
 * Removes the build-time prerendered SEO content (#seo-prerender) from the
 * DOM and marks the body as mounted. Called from src/main.tsx after React
 * mounts so crawlers/SEO tools never see it post-hydration (which would
 * cause duplicate <h1> a11y issues).
 *
 * Extracted into its own module so it can be unit-tested without booting
 * the full SPA.
 */
export function cleanupSeoPrerender(doc: Document = document): void {
  doc.body.classList.add('app-mounted');
  const seoNode = doc.getElementById('seo-prerender');
  if (seoNode && seoNode.parentNode) {
    seoNode.parentNode.removeChild(seoNode);
  }
}
